<template>
  <div class="ui top fixed borderless menu">
    <div class="ui container" v-if="menu.length > 0">
      <vsm-menu ref="myMenu" :menu="menu" handler="hover" :screen-offset="50">
        <li slot="before-nav" class="logo vsm-section vsm-mob-full">
          <router-link to="/" class="header item logo-section">
            <img class="ui logo" :src="logo" />
            {{ appName }}
          </router-link>
        </li>

        <template #default="data">
          <component
            :is="data.item.content"
            :category="data.item.data"
            :key="data.item.title"
            @onLoadProducts="loadProducts"
            @onCopyLink="copy"
          />
        </template>

        <template slot="after-nav">
          <div class="cart-icon right menu">
            <a class="ui item vsm-mob-hide" v-if="canSell" @click="reviews">
              <i class="yellow star icon"></i>
              <div class="">Reseñas</div>
            </a>
            <a
              class="ui item vsm-mob-hide"
              v-if="isAuthenticated && canSell"
              @click="goProfile"
            >
              <i class="user icon"></i>
              <div class="">Mi Cuenta</div>
            </a>

            <a
              class="ui item vsm-mob-hide"
              v-if="isAuthenticated && canSell"
              @click="goOrders"
            >
              <i class="dolly icon"></i>
              <div class="">Mis pedidos</div>
            </a>

            <span class="timer">
              <BaseTimer :limit="timeRemaining" :maxLimit="maxLimit" />
            </span>
            <a class="ui item" @click="goCart" v-if="canSell">
              <i class="cart icon"></i>
              <div class="ui teal label">{{ totalItems }}</div>
            </a>

            <div
              class="ui item vsm-mob-hide"
              v-if="!isAuthenticated && canSell"
              @click="signup"
            >
              <div class="ui primary button">Regístrate</div>
            </div>

            <div
              class="ui item vsm-mob-hide"
              v-if="!isAuthenticated && canSell"
              @click="login"
            >
              <div class="ui basic primary button">Login</div>
            </div>

            <a
              class="ui item vsm-mob-hide"
              v-if="isAuthenticated && canSell"
              @click="logout"
            >
              <i class="close icon"></i>
              <div class="">Cerrar sesión</div>
            </a>
          </div>
          <vsm-mob class="mobile-menu" v-model="mobileMenu">
            <MobileDropdown
              :menu="menu"
              @onLoadProducts="loadProducts"
              @onClose="closeMenu"
              @onCopyLink="copy"
            />
          </vsm-mob>
        </template>
      </vsm-menu>
    </div>
  </div>
</template>

<script>
import "vue-stripe-menu/dist/vue-stripe-menu.css";
import CategoryDropdown from "./CategoryDropdown";
import MobileDropdown from "./MobileDropdown";
import BaseTimer from "../cart/BaseTimer";

export default {
  name: "Header2",
  props: ["menu"],
  data() {
    return {
      mobileMenu: false,
    };
  },
  computed: {
    totalItems: function () {
      return this.$store.getters["cart/totalItems"];
    },
    isAuthenticated: function () {
      return this.$store.getters["auth/isAuthenticated"];
    },
    categories: function () {
      return this.$store.getters["categories/getMenuCats"];
    },
    logo: function () {
      return this.$store.getters["application/getLogo"];
    },
    appName: function () {
      return this.$store.getters["application/getName"];
    },
    timeRemaining: function () {
      return this.$store.getters["cart/getTimeRemaining"];
    },
    maxLimit: function () {
      return this.$store.getters["application/getCartTimeout"] * 60;
    },
    canSell: function () {
      return this.$store.getters["application/canSell"];
    },
    appDomain: function () {
      return this.$store.getters["application/domain"];
    },
  },
  methods: {
    reviews: function () {
      this.$router.push({ name: "ReviewPage" }).catch(() => {});
    },
    login: function () {
      this.$router.push({ name: "Login" }).catch(() => {});
    },
    logout: function () {
      this.$store.dispatch("auth/logout").catch(() => {});
      this.goHome();
    },
    signup: function () {
      this.$router.push({ name: "Signup" }).catch(() => {});
    },
    goHome: function () {
      this.$router.push({ name: "Home" }).catch(() => {});
    },
    goProfile: function () {
      this.$router.push("/customer/profile").catch(() => {});
    },
    goOrders: function () {
      this.$router.push("/orders").catch(() => {});
    },
    goCart: function () {
      this.$router.push({ name: "Cart" }).catch(() => {});
    },
    loadProducts: function (payload) {
      this.$emit("onLoadProducts", payload);
      this.closeMenu();
    },
    closeMenu: function () {
      this.mobileMenu = !this.mobileMenu;
    },
    copy: async function (payload) {
      const link = payload.brandId
        ? `https://${this.appDomain}/?category=${payload.categoryId}&brand=${payload.brandId}`
        : `https://${this.appDomain}/?category=${payload.categoryId}`;

      const text = `Mira la colección que tenemos en ${this.appName}\n${link}`;

      console.log(text);

      if (navigator.share) {
        navigator
          .share({
            title: "Mira la colección de ropa que tenemos en " + this.appName,
            url: link,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
      } else {
        try {
          await navigator.clipboard.writeText(text);
          console.log("Text or Page URL copied");
        } catch (err) {
          console.error("Failed to copy: ", err);
        }
      }
    },
  },
  components: {
    CategoryDropdown,
    MobileDropdown,
    BaseTimer,
  },
};
</script>

<style lang="scss">
:root {
  --primary: #333;
  --secondary: #777;
  --link: #f9f9f9f9;
  --hover-link: #fff;
}

.logo {
  float: left;

  img {
    user-select: none;
    max-width: 35px;
    margin-right: 5px;
  }
}

.vsm-menu {
  position: relative;
  width: 100%;
  nav {
    margin: 0 10px;
  }
  ul {
    margin: 0 auto;
  }
}

.vsm-root {
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 53px;
}

.vsm-section_menu {
  flex: 1 1 auto;
  > * {
    padding: 0 25px;
    font-weight: 500;
    font-family: inherit;
  }
}

.vsm-link {
  font-size: 15px;
}

.cart-icon {
  float: right;
}
.mobile-menu {
  max-height: 450px;
  max-width: 300px;
  overflow-y: auto;
}

.mobile-content {
  background-color: gray;
  max-height: 550px;
  width: 500px;
  overflow-y: auto;
}

.scroll-section {
}

.mobile-header {
  background: #3e5165;
  padding-top: 10px;
}

.mobile-title {
  padding-left: 20px;
  color: #fff;
  margin-bottom: 20px;
}

ul.menu {
  padding: 0;
  list-style: none;
  width: 100%;
  margin: 20px auto;
  font-family: "Century Gothic";
  box-shadow: 0px 0px 25px #00000070;
  clear: both;
  display: table;
  margin-bottom: 100px;

  .menu-item {
    font-size: 19px;
    //border-top: 1px solid #324252;
    border-bottom: 0px solid #324252;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 50px;
    vertical-align: sub;
    background: #cce6ff;
    clear: both;

    a {
      text-decoration: none;
      color: #106ebd;
      padding: 8px 0px 8px 45px;
      display: block;
      height: 100%;
      box-sizing: border-box;
      &:hover {
        background-color: #b3daff;
        transition: 300ms all;
        color: #000;
      }
    }
  }

  .list {
    font-size: 19px;
    border-bottom: 0px solid #324252;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 50px;
    vertical-align: sub;
    background: #cce6ff;
    clear: both;

    a {
      text-decoration: none;
      color: #106ebd;
      padding: 8px 0px 8px 45px;
      display: block;
      height: 100%;
      box-sizing: border-box;
      &:hover {
        background-color: #b3daff;
        transition: 300ms all;
        color: #066fca;
      }
    }
    .items {
      height: 10px;
      overflow: hidden;
      a {
        padding: 3px 45px 3px;
        &:hover {
          background-color: #cce6ff;
          color: #0059b3;
          transition: 300ms all;
        }
      }
    }
    &:last-child {
      //border-bottom: none;
    }
  }
  .active {
    > .items {
      display: block;
      background: #e6f2ff;
      padding: 0px;
      height: auto;
      color: #fff;
      transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
      transition: all 200ms;
      clear: both;
      float: left;
      width: 100%;
      li {
        padding: 0px;
        border-bottom: 0px solid #324252;
        list-style: none;
      }
      li:last-child {
        border-color: transparent;
        padding-bottom: 0px;
      }
      .active {
        > .items {
          background-color: #cedce8;
        }
      }
    }
    > a {
      color: #0065bb;
      text-transform: uppercase;
      font-weight: bold;
    }
    .list {
      background: #f0f0f0;
      a {
        padding: 8px 0px 8px 45px;
      }
    }
  }

  .sub-list {
    font-size: 16px;
    border-color: transparent;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 50px;
    vertical-align: sub;
    background: #e6f2ff;
    clear: both;

    a {
      text-decoration: none;
      color: #106ebd;
      padding: 8px 0px 8px 45px;
      display: block;
      height: 100%;
      box-sizing: border-box;
      &:hover {
        background-color: rgb(239, 244, 250);
        transition: 300ms all;
        color: #066fca;
      }
    }
    .sub-items {
      height: 10px;
      overflow: hidden;
      a {
        padding: 3px 45px 3px;
        &:hover {
          background: #6fabbc;
          color: #fff;
          transition: 300ms all;
        }
      }
    }
    &:last-child {
      //border-bottom: none;
    }
  }
  .subActive {
    > .sub-items {
      display: block;
      background: #93c7d6;
      padding: 0px;
      height: auto;
      color: #fff;
      transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
      transition: all 200ms;
      clear: both;
      float: left;
      width: 100%;
      li {
        padding: 0px;
        border-bottom: 0px;
        list-style: none;
      }
      li:last-child {
        border-color: transparent;
        padding-bottom: 0px;
      }
      .active {
        > .items {
          background: #93c7d6;
        }
      }
    }
    > a {
      background: #76b1c3;
      color: #e6f2ff;
      text-transform: uppercase;
      font-weight: bold;
    }
    .list {
      background: #93c7d6;
      a {
        padding: 8px 0px 8px 45px;
      }
    }
  }
}

.timer {
  //  margin-top: -10px;
  margin-right: 10px;
}

@media only screen and (max-width: 800px) {
  .vsm-mob-hide {
    display: none !important;
  }
}
</style>

<style lang="css">
.blink-01 {
  animation: blinking-01 1.5s infinite;
}

.blink-02 {
  animation: blinking-02 1.5s infinite;
}

.blink-03 {
  animation: blinking-03 1.5s infinite;
}

.blink-04 {
  animation: blinking-04 1.5s infinite;
}

@keyframes blinking-01 {
  0% {
    color: #ffffff;
    background-color: #d9017a;
  }
  100% {
  }
}

@keyframes blinking-02 {
  0% {
    color: #ffffff;
    background-color: #4cc417;
  }
  100% {
  }
}

@keyframes blinking-03 {
  0% {
    color: #ffffff;
    background-color: #e41b17;
  }
  100% {
  }
}

@keyframes blinking-04 {
  0% {
    color: #ffffff;
    background-color: #9d00ff;
  }
  100% {
  }
}
</style>
